export const getCurrentPathname = (state, location) => location.pathname;
